import * as Models from "../models/index"

export const LOAD_INITIAL_DATA = "LOAD_INITIAL_DATA";
export type LOAD_INITIAL_DATA_PAYLOAD = Models.InitialData;
export const CHANGE_BROWSER_REGISTRATION = "CHANGE_BROWSER_REGISTRATION";
export type CHANGE_BROWSER_REGISTRATION_PAYLOAD = boolean;

export const CHANGE_LOGIN_USERNAME = "CHANGE_LOGIN_USERNAME";
export type CHANGE_LOGIN_USERNAME_PAYLOAD = string;

export const CHANGE_LOGIN_PASSWORD = "CHANGE_LOGIN_PASSWORD";
export type CHANGE_LOGIN_PASSWORD_PAYLOAD = string;

export const CHANGE_LOGIN_PROCESSING_STATUS = "CHANGE_LOGIN_PROCESSING_STATUS";
export type CHANGE_LOGIN_PROCESSING_STATUS_PAYLOAD = boolean;

export const SET_LOGIN_RESPONSE = "SET_LOGIN_RESPONSE";
export type SET_LOGIN_RESPONSE_PAYLOAD = Models.LoginResponse;

export const SET_IS_NEEDED_TO_CHANGE_PWD = "SET_IS_NEEDED_TO_CHANGE_PWD";
export type SET_IS_NEEDED_TO_CHANGE_PWD_PAYLOAD = boolean;

export const REFRESH_APP_WINDOW_SIZE = "REFRESH_APP_WINDOW_SIZE";
export interface REFRESH_APP_WINDOW_SIZE_PAYLOAD {
    isMobileMode: boolean
}

export const PWD_RECOVERY_START="PWD_RECOVERY_START";

export const PWD_RECOVERY_SET_USERNAME = "PWD_RECOVERY_SET_USERNAME";

export const PWD_RECOVERY_PENDING = "PWD_RECOVERY_PENDING";
export const PWD_RECOVERY_SET_QUESTIONS = "PWD_RECOVERY_SET_QUESTIONS";

export const PWD_RECOVERY_GO_TO_QUESTIONS = "PWD_RECOVERY_GO_TO_QUESTIONS";
export type PWD_RECOVERY_GO_TO_QUESTIONS_PAYLOAD = void;

export const PWD_RECOVERY_CHECK_ANSWERS = "PWD_RECOVERY_CHECK_ANSWERS";
export type PWD_RECOVERY_CHECK_ANSWERS_PAYLOAD = void;

export const PWD_RECOVERY_UPDATE_ANSWER = "PWD_RECOVERY_UPDATE_ANSWER";
export const PWD_RECOVERY_RESET = "PWD_RECOVERY_RESET";

export const PWD_EXPIRED_PENDING = "PWD_EXPIRED_PENDING";
export const PWD_EXPIRED_UPDATE_OLD_PASSWORD = "PWD_EXPIRED_UPDATE_OLD_PASSWORD";
export const PWD_EXPIRED_RESET_PASSWORD = "PWD_EXPIRED_RESET_PASSWORD";
export const SHOW_FORGOT_USERNAME_MESS = "SHOW_FORGOT_USERNAME_MESS";

export const PWD_UPDATE_PASSWORD = "PWD_UPDATE_PASSWORD";
export const PWD_UPDATE_CONFIRM_PASSWORD = "PWD_UPDATE_CONFIRM_PASSWORD";

export const PWD_UPDATE_VALIDATION_USER_PASSWORD = "PWD_UPDATE_VALIDATION_USER_PASSWORD";
export type PWD_UPDATE_VALIDATION_USER_PASSWORD_PAYLOAD = Models.ValidateUserPassword_Response_Client[]

export const PWD_UPDATE_VALIDATION_OLD_PASSWORD = "PWD_UPDATE_VALIDATION_OLD_PASSWORD";
export type PWD_UPDATE_VALIDATION_OLD_PASSWORD_PAYLOAD = Models.ValidateUserPassword_Response_Client

export const PWD_UPDATE_MATCHING_PASSWORD_AND_CONFIRM = "PWD_UPDATE_MATCHING_PASSWORD_AND_CONFIRM";

export const PWD_UPDATE_IS_NEEDED_VALIDATION = "PWD_UPDATE_IS_NEEDED_VALIDATION";

export const PWD_UPDATE_SECRET_ANSWERS = "PWD_UPDATE_SECRET_ANSWERS"

export const PWD_UPDATE_SECRET_ANSWER_TEXT = "PWD_UPDATE_SECRET_ANSWER_TEXT"

export const PWD_SET_DEFAULT = "PWD_SET_DEFAULT";

export const SET_SECRET_QUESTIONS = "SET_SECRET_QUESTIONS";

export const CHANGE_VISIBLE_SELECT_SECRET_QUESTION = "CHANGE_VISIBLE_SELECT_SECRET_QUESTION";